/**
 * Returns the base URL for the site, ensuring HTTPS in production.
 * Used by localisedLinks, Breadcrumbs, and any code that needs the site origin.
 */
export function getBaseUrl(): string {
  const baseUrl = typeof process !== "undefined"
    ? (process.env.BASE_URL ?? null)
    : window.location.origin;

  if (baseUrl === null) {
    throw new Error("Can't figure out baseURL. Check BASE_URL env var is defined for server side");
  }

  // Ensure HTTPS in production
  if (typeof process !== "undefined" && process.env.NODE_ENV === "production") {
    return baseUrl.replace(/^http:\/\//, "https://");
  }

  return baseUrl;
}
